<nz-card>
  <div class="toolbar">
    <h1>{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.TITLE' | translate }}</h1>
    <button nz-button nzType="primary" type="button" (click)="create()">
      {{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.CREATE' | translate }}
    </button>
  </div>

  <div class="announcement-table-scroll">
    <nz-table class="announcement-table" [nzData]="announcements" [nzLoading]="loading" [nzPageSize]="10" nzTableLayout="fixed">
      <thead>
        <tr>
          <th nzWidth="112px">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.STATUS' | translate }}</th>
          <th>{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.MESSAGE_DE' | translate }}</th>
          <th>{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.MESSAGE_EN' | translate }}</th>
          <th nzWidth="150px">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.DESTINATION' | translate }}</th>
          <th nzWidth="150px">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.UPDATED_AT' | translate }}</th>
          <th nzWidth="260px" class="actions-header">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let announcement of announcements">
          <td class="status-cell">
            <nz-tag [nzColor]="announcement.active ? 'green' : 'default'">
              {{ (announcement.active ? 'ADMIN.PLATFORM_ANNOUNCEMENTS.STATUS_ACTIVE' : 'ADMIN.PLATFORM_ANNOUNCEMENTS.STATUS_INACTIVE') | translate }}
            </nz-tag>
          </td>
          <td class="message-preview">{{ announcement.messageDe }}</td>
          <td class="message-preview">{{ announcement.messageEn || '—' }}</td>
          <td>{{ targetLabel(announcement) }}</td>
          <td>{{ announcement.updatedAt | date: 'short' }}</td>
          <td class="actions-cell">
            <div class="actions">
              <button nz-button nzType="link" type="button" (click)="edit(announcement)">{{ 'COMMON.EDIT' | translate }}</button>
              <button *ngIf="!announcement.active" nz-button nzType="link" type="button" [nzLoading]="updatingId === announcement._id"
                      (click)="activate(announcement)">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.ACTIVATE' | translate }}</button>
              <button *ngIf="announcement.active" nz-button nzType="link" type="button" [nzLoading]="updatingId === announcement._id"
                      (click)="deactivate(announcement)">{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.DEACTIVATE' | translate }}</button>
              <button nz-button nzType="link" nzDanger type="button" [nzLoading]="updatingId === announcement._id"
                      [nzPopconfirmTitle]="'ADMIN.PLATFORM_ANNOUNCEMENTS.DELETE_CONFIRM' | translate"
                      [nzOkText]="'COMMON.DELETE' | translate" [nzCancelText]="'COMMON.CANCEL' | translate"
                      nz-popconfirm (nzOnConfirm)="delete(announcement)">{{ 'COMMON.DELETE' | translate }}</button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-card>
